<template>
  <div class="cex">
    <p class="cex-nota">
      <v-icon size="15" color="#8a939c">mdi-information-outline</v-icon>
      <span
        >A CVC enviou um XML com o mesmo código de reserva de uma reserva que já
        está no Phoenix, mas com outro voucher. O Phoenix ignora o XML novo.
        Clique para ver a diferença de campos.</span
      >
    </p>

    <div v-if="items.length" class="detail-table-wrap">
      <table class="detail-table cex-table">
        <colgroup>
          <col class="col-chevron" />
          <col class="col-codigo" />
          <col />
          <col class="col-reserva" />
          <col class="col-data" />
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th>Código da reserva</th>
            <th>Voucher novo × existente</th>
            <th>Reserva no Phoenix</th>
            <th>Detectada</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="c in items">
            <tr
              :key="c.id"
              class="cex-row"
              :class="{ 'is-open': aberto === c.id }"
              @click="aberto = aberto === c.id ? null : c.id"
            >
              <td class="cex-chevron">
                <v-icon
                  size="18"
                  class="cex-chev"
                  :class="{ 'is-open': aberto === c.id }"
                  >mdi-chevron-right</v-icon
                >
              </td>
              <td class="voucher-cell">{{ c.codigo }}</td>
              <td>
                <span class="cex-voucher">{{ c.voucherNovo }}</span>
                <span class="muted"> × </span>
                <span class="cex-voucher">{{ c.voucherExistente }}</span>
                <div v-if="c.cliente" class="muted cex-cliente">
                  {{ c.cliente }}
                </div>
              </td>
              <td>
                {{ c.phoenix.code || "—" }}
              </td>
              <td class="muted">{{ c.primeiraVez }}</td>
            </tr>
            <tr v-if="aberto === c.id" :key="c.id + '-det'" class="cex-det">
              <td colspan="5">
                <div class="cex-blocos">
                  <div>
                    <div class="cex-titulo">
                      O que mudou do voucher antigo para o voucher novo
                      <span class="cex-qtd">{{ linhas(c).length }}</span>
                    </div>
                    <table class="cex-dif cex-dif--destaque">
                      <thead>
                        <tr>
                          <th>Campo</th>
                          <th>Voucher antigo (no Phoenix) {{ c.voucherExistente }}</th>
                          <th>Voucher novo (XML da CVC) {{ c.voucherNovo }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(d, k) in linhas(c)" :key="k">
                          <td class="cex-campo">{{ d.campo }}</td>
                          <td class="cex-velho">{{ d.phoenix || "—" }}</td>
                          <td class="cex-novo">{{ d.xml_novo || "—" }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tfoot v-if="meta.listadas < meta.total">
          <tr>
            <td colspan="5">
              Listando {{ meta.listadas }} de {{ meta.total }} no período.
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div v-else class="detail-empty detail-empty--ok">
      <v-icon size="18" color="#0f7a6e">mdi-check-circle-outline</v-icon>
      Nenhum código de reserva repetido com outro voucher no período.
    </div>
  </div>
</template>

<script>
export default {
  name: "CodigoExistente",
  props: {
    items: { type: Array, default: () => [] },
    meta: { type: Object, default: () => ({ total: 0, listadas: 0 }) },
  },
  data() {
    return { aberto: null };
  },
  methods: {
    // Todos os campos que mudaram do voucher antigo (Phoenix) para o novo (XML), com o nome exato do campo.
    // Aceita tambem os nomes curtos das execucoes antigas do agente.
    linhas(c) {
      const NOME = {
        "Datas|Saída": "Data de saída",
        "Datas|Retorno": "Data de retorno",
        "Passageiros|Quantidade": "Quantidade de passageiros",
        "Passageiros|Nomes só no XML novo": "Passageiros só no XML novo",
        "Passageiros|Nomes só no Phoenix": "Passageiros só no Phoenix",
      };
      return (c.diferencas || []).map((d) => ({
        ...d,
        campo: NOME[`${d.secao}|${d.campo}`] || d.campo,
      }));
    },
  },
};
</script>

<style scoped lang="scss">
@import "../_shared/detail.scss";

.cex-nota {
  display: flex;
  gap: 6px;
  align-items: flex-start;
  margin: 0 0 12px;
  color: #6b747d;
  font-size: 0.85rem;
}
.cex-table {
  col.col-chevron {
    width: 36px;
  }
  col.col-codigo {
    width: 150px;
  }
  col.col-reserva {
    width: 230px;
  }
  col.col-data {
    width: 150px;
  }
}
.cex-row {
  cursor: pointer;

  &:hover,
  &.is-open {
    background: #f6f8fa;
  }
}
.cex-chevron {
  padding-right: 0;
}
.cex-chev {
  transition: transform 0.15s ease;

  &.is-open {
    transform: rotate(90deg);
  }
}
.cex-voucher {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.85rem;
}
.cex-cliente {
  font-size: 0.8rem;
}
.cex-chips {
  margin-top: 4px;
}
.cex-chip {
  display: inline-block;
  margin: 0 6px 2px 0;
  padding: 1px 9px;
  border-radius: 10px;
  font-size: 0.72rem;
  font-weight: 600;
  background: #fdf0dc;
  color: #b06a12;

  &--nada {
    background: #eef2f6;
    color: #6b747d;
    font-weight: 500;
  }
}
.cex-qtd {
  margin-left: 6px;
  padding: 0 8px;
  border-radius: 10px;
  background: #fdf0dc;
  color: #b06a12;
  font-size: 0.75rem;
}
.cex-campo {
  font-weight: 600;
  white-space: nowrap;
}
.cex-novo {
  background: #eaf6f1;
  color: #0b5f55;
  font-weight: 600;
}
.cex-velho {
  background: #fdeeee;
  color: #a33a3a;
}
.cex-det > td {
  background: #fafbfc;
  padding: 12px 16px 16px 44px;
}
.cex-blocos {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.cex-titulo {
  font-weight: 600;
  font-size: 0.85rem;
  margin-bottom: 6px;
}
.cex-dif {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;

  th,
  td {
    text-align: left;
    padding: 6px 10px;
    border-bottom: 1px solid #e6eaee;
    vertical-align: top;
    word-break: break-word;
  }
  th {
    color: #6b747d;
    font-weight: 600;
  }
}
</style>
